import qrcode from 'qrcode'

class QRCodeGenerator {
  static toDataURL(barcode) {
    return qrcode.toDataURL(barcode)
  }
}
export default QRCodeGenerator
